export const tableOption = {
    dialogDrag: true,
    index: true,
    indexLabel: '序号',
    menuAlign: 'center',
    align: 'center',
    menuType: 'text',
    searchShow: false,
    excelBtn: false,
    indexFixed: false,
    printBtn: false,
    viewBtn: false,
    addBtn: false,
    delBtn: false,
    editBtn: false,
    refreshBtn: false,
    columnBtn: false,
    border: false,
    menu: false,
    dialogMenuPosition:'center',
    menuWidth: 150,
    header: false,
    column: [
        {
            label: '平台消耗小竹叶',
            prop: 'zhuye_add'
        },
        {
            label: '平台回收小竹叶',
            prop: 'zhuye_reduce'
        }
    ]
}

export const tableOption2 = {
    dialogDrag: true,
    index: true,
    indexLabel: '序号',
    menuAlign: 'center',
    align: 'center',
    menuType: 'text',
    searchShow: false,
    excelBtn: false,
    indexFixed: false,
    printBtn: false,
    viewBtn: false,
    addBtn: false,
    delBtn: false,
    editBtn: false,
    refreshBtn: false,
    columnBtn: false,
    border: false,
    menu: false,
    dialogMenuPosition:'center',
    menuWidth: 150,
    header: false,
    column: [
        {
            label: '用户',
            prop: 'username'
        },
        {
            label: '描述',
            prop: 'memo'
        },
        {
            label: '金额',
            prop: 'money'
        }
    ]
}